import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _40b0075c = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _e57ad8bc = () => interopDefault(import('../pages/activity/index.vue' /* webpackChunkName: "pages/activity/index" */))
const _376d3f5c = () => interopDefault(import('../pages/antincp/index.vue' /* webpackChunkName: "pages/antincp/index" */))
const _106690ba = () => interopDefault(import('../pages/assetSingleChengguo/index.vue' /* webpackChunkName: "pages/assetSingleChengguo/index" */))
const _3f0e9374 = () => interopDefault(import('../pages/bearer/index.vue' /* webpackChunkName: "pages/bearer/index" */))
const _63d4a33d = () => interopDefault(import('../pages/bearerJS/index.vue' /* webpackChunkName: "pages/bearerJS/index" */))
const _39b16fe0 = () => interopDefault(import('../pages/bearerNj/index.vue' /* webpackChunkName: "pages/bearerNj/index" */))
const _1adc9add = () => interopDefault(import('../pages/bid2021/index.vue' /* webpackChunkName: "pages/bid2021/index" */))
const _a07d64c4 = () => interopDefault(import('../pages/bid2022/index.vue' /* webpackChunkName: "pages/bid2022/index" */))
const _107d3403 = () => interopDefault(import('../pages/bid2022-real/index.vue' /* webpackChunkName: "pages/bid2022-real/index" */))
const _1be1dc3c = () => interopDefault(import('../pages/bid2023-real/index.vue' /* webpackChunkName: "pages/bid2023-real/index" */))
const _34d49875 = () => interopDefault(import('../pages/branch/index.vue' /* webpackChunkName: "pages/branch/index" */))
const _312ede8c = () => interopDefault(import('../pages/college/index.vue' /* webpackChunkName: "pages/college/index" */))
const _d6da2bae = () => interopDefault(import('../pages/collegeActivity/index.vue' /* webpackChunkName: "pages/collegeActivity/index" */))
const _5882e422 = () => interopDefault(import('../pages/collegeChengguo/index.vue' /* webpackChunkName: "pages/collegeChengguo/index" */))
const _0c3b1f79 = () => interopDefault(import('../pages/collegeHome/index.vue' /* webpackChunkName: "pages/collegeHome/index" */))
const _379f0f10 = () => interopDefault(import('../pages/collegeList/index.vue' /* webpackChunkName: "pages/collegeList/index" */))
const _4609f342 = () => interopDefault(import('../pages/collegeMien/index.vue' /* webpackChunkName: "pages/collegeMien/index" */))
const _099392c8 = () => interopDefault(import('../pages/collegeNew/index.vue' /* webpackChunkName: "pages/collegeNew/index" */))
const _77c1d46d = () => interopDefault(import('../pages/collegeNews/index.vue' /* webpackChunkName: "pages/collegeNews/index" */))
const _441e5542 = () => interopDefault(import('../pages/collegeSearch/index.vue' /* webpackChunkName: "pages/collegeSearch/index" */))
const _279f1d68 = () => interopDefault(import('../pages/crowdsourcing/index.vue' /* webpackChunkName: "pages/crowdsourcing/index" */))
const _3abd4444 = () => interopDefault(import('../pages/demand/index.vue' /* webpackChunkName: "pages/demand/index" */))
const _af4035a8 = () => interopDefault(import('../pages/demandDashboard/index.vue' /* webpackChunkName: "pages/demandDashboard/index" */))
const _30d96d33 = () => interopDefault(import('../pages/demo.vue' /* webpackChunkName: "pages/demo" */))
const _f37de2a2 = () => interopDefault(import('../pages/dqxqLb/index.vue' /* webpackChunkName: "pages/dqxqLb/index" */))
const _24544854 = () => interopDefault(import('../pages/ecoBlank/index.vue' /* webpackChunkName: "pages/ecoBlank/index" */))
const _00561f9c = () => interopDefault(import('../pages/ecoServices/index.vue' /* webpackChunkName: "pages/ecoServices/index" */))
const _3c3356fd = () => interopDefault(import('../pages/expert/index.vue' /* webpackChunkName: "pages/expert/index" */))
const _5a027186 = () => interopDefault(import('../pages/finance/index.vue' /* webpackChunkName: "pages/finance/index" */))
const _3813e013 = () => interopDefault(import('../pages/forgetpwd/index.vue' /* webpackChunkName: "pages/forgetpwd/index" */))
const _459375b9 = () => interopDefault(import('../pages/goods/index.vue' /* webpackChunkName: "pages/goods/index" */))
const _1616632e = () => interopDefault(import('../pages/goods1/index.vue' /* webpackChunkName: "pages/goods1/index" */))
const _23a83554 = () => interopDefault(import('../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _ebfffcfc = () => interopDefault(import('../pages/Intermediary/index.vue' /* webpackChunkName: "pages/Intermediary/index" */))
const _0fb3cb84 = () => interopDefault(import('../pages/jtop/index.vue' /* webpackChunkName: "pages/jtop/index" */))
const _2ec6250a = () => interopDefault(import('../pages/jtop2021/index.vue' /* webpackChunkName: "pages/jtop2021/index" */))
const _3527d2f0 = () => interopDefault(import('../pages/jtopTest/index.vue' /* webpackChunkName: "pages/jtopTest/index" */))
const _06d56546 = () => interopDefault(import('../pages/laboratory/index.vue' /* webpackChunkName: "pages/laboratory/index" */))
const _104b5ad0 = () => interopDefault(import('../pages/listed/index.vue' /* webpackChunkName: "pages/listed/index" */))
const _5e75dbe8 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _8342595e = () => interopDefault(import('../pages/loginThird/index.vue' /* webpackChunkName: "pages/loginThird/index" */))
const _a0a55d94 = () => interopDefault(import('../pages/manageList/index.vue' /* webpackChunkName: "pages/manageList/index" */))
const _fba9bb34 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _593c8c45 = () => interopDefault(import('../pages/onlineService/index.vue' /* webpackChunkName: "pages/onlineService/index" */))
const _74ca7276 = () => interopDefault(import('../pages/points/index.vue' /* webpackChunkName: "pages/points/index" */))
const _7ae79918 = () => interopDefault(import('../pages/presentationDemand/index.vue' /* webpackChunkName: "pages/presentationDemand/index" */))
const _3b2e4548 = () => interopDefault(import('../pages/publicity/index.vue' /* webpackChunkName: "pages/publicity/index" */))
const _47873394 = () => interopDefault(import('../pages/register/index.vue' /* webpackChunkName: "pages/register/index" */))
const _5670f987 = () => interopDefault(import('../pages/report/index.vue' /* webpackChunkName: "pages/report/index" */))
const _74cd87dd = () => interopDefault(import('../pages/rmxqLb/index.vue' /* webpackChunkName: "pages/rmxqLb/index" */))
const _78958560 = () => interopDefault(import('../pages/roadShow/index.vue' /* webpackChunkName: "pages/roadShow/index" */))
const _596c08fb = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _7a32684c = () => interopDefault(import('../pages/serviceGuide/index.vue' /* webpackChunkName: "pages/serviceGuide/index" */))
const _04ee1af1 = () => interopDefault(import('../pages/serviceHall/index.vue' /* webpackChunkName: "pages/serviceHall/index" */))
const _2d94ee74 = () => interopDefault(import('../pages/shop.vue' /* webpackChunkName: "pages/shop" */))
const _8a643a6e = () => interopDefault(import('../pages/shop/index.vue' /* webpackChunkName: "pages/shop/index" */))
const _c1f3c08e = () => interopDefault(import('../pages/shop/index2.vue' /* webpackChunkName: "pages/shop/index2" */))
const _13f2b35e = () => interopDefault(import('../pages/shop/indexCopy.vue' /* webpackChunkName: "pages/shop/indexCopy" */))
const _1c04a197 = () => interopDefault(import('../pages/shop/orgAnalysis.vue' /* webpackChunkName: "pages/shop/orgAnalysis" */))
const _fea33d12 = () => interopDefault(import('../pages/shop/shopGoods.vue' /* webpackChunkName: "pages/shop/shopGoods" */))
const _d595126a = () => interopDefault(import('../pages/shop/shopGoods2.vue' /* webpackChunkName: "pages/shop/shopGoods2" */))
const _3d93395c = () => interopDefault(import('../pages/shop2.vue' /* webpackChunkName: "pages/shop2" */))
const _4c25da4a = () => interopDefault(import('../pages/shopCopy.vue' /* webpackChunkName: "pages/shopCopy" */))
const _360f5892 = () => interopDefault(import('../pages/statement/index.vue' /* webpackChunkName: "pages/statement/index" */))
const _e1ca3e7e = () => interopDefault(import('../pages/stzqLb/index.vue' /* webpackChunkName: "pages/stzqLb/index" */))
const _7e8a1f82 = () => interopDefault(import('../pages/supply/index.vue' /* webpackChunkName: "pages/supply/index" */))
const _08161af6 = () => interopDefault(import('../pages/supply1/index.vue' /* webpackChunkName: "pages/supply1/index" */))
const _455cd2d4 = () => interopDefault(import('../pages/supplyNew/index.vue' /* webpackChunkName: "pages/supplyNew/index" */))
const _3ecaa60b = () => interopDefault(import('../pages/talentZone/index.vue' /* webpackChunkName: "pages/talentZone/index" */))
const _3805eeb0 = () => interopDefault(import('../pages/technicalContractsRegistration/index.vue' /* webpackChunkName: "pages/technicalContractsRegistration/index" */))
const _4025c590 = () => interopDefault(import('../pages/technologicalAchievement/index.vue' /* webpackChunkName: "pages/technologicalAchievement/index" */))
const _437bf965 = () => interopDefault(import('../pages/test/index.vue' /* webpackChunkName: "pages/test/index" */))
const _2d5c089a = () => interopDefault(import('../pages/thirdPartyAuth/index.vue' /* webpackChunkName: "pages/thirdPartyAuth/index" */))
const _355f6a4d = () => interopDefault(import('../pages/transactionScreen/index.vue' /* webpackChunkName: "pages/transactionScreen/index" */))
const _46bb1f78 = () => interopDefault(import('../pages/tzj2021/index.vue' /* webpackChunkName: "pages/tzj2021/index" */))
const _71872305 = () => interopDefault(import('../pages/tzj2022/index.vue' /* webpackChunkName: "pages/tzj2022/index" */))
const _6c50b208 = () => interopDefault(import('../pages/tzj2022-real/index.vue' /* webpackChunkName: "pages/tzj2022-real/index" */))
const _a92cf64a = () => interopDefault(import('../pages/tzj2023-real/index.vue' /* webpackChunkName: "pages/tzj2023-real/index" */))
const _46e7a2e4 = () => interopDefault(import('../pages/yrd/index.vue' /* webpackChunkName: "pages/yrd/index" */))
const _59db5840 = () => interopDefault(import('../pages/yrd-jtop/index.vue' /* webpackChunkName: "pages/yrd-jtop/index" */))
const _484059cb = () => interopDefault(import('../pages/yrd2021/index.vue' /* webpackChunkName: "pages/yrd2021/index" */))
const _599a335e = () => interopDefault(import('../pages/yrdgoods/index.vue' /* webpackChunkName: "pages/yrdgoods/index" */))
const _36587b20 = () => interopDefault(import('../pages/zdlyLb/index.vue' /* webpackChunkName: "pages/zdlyLb/index" */))
const _5a97f4e0 = () => interopDefault(import('../pages/achievement/achievementDetail.vue' /* webpackChunkName: "pages/achievement/achievementDetail" */))
const _92485f26 = () => interopDefault(import('../pages/achievement/achievementList.vue' /* webpackChunkName: "pages/achievement/achievementList" */))
const _0476d2b4 = () => interopDefault(import('../pages/achievement/components/index.js' /* webpackChunkName: "pages/achievement/components/index" */))
const _34c530a0 = () => interopDefault(import('../pages/activity/activityDetail.vue' /* webpackChunkName: "pages/activity/activityDetail" */))
const _d469ac28 = () => interopDefault(import('../pages/bearer/list.vue' /* webpackChunkName: "pages/bearer/list" */))
const _7bda1163 = () => interopDefault(import('../pages/bid2021/list.vue' /* webpackChunkName: "pages/bid2021/list" */))
const _b6628906 = () => interopDefault(import('../pages/bid2022-real/list.vue' /* webpackChunkName: "pages/bid2022-real/list" */))
const _70238282 = () => interopDefault(import('../pages/bid2022/list.vue' /* webpackChunkName: "pages/bid2022/list" */))
const _02abb484 = () => interopDefault(import('../pages/bid2023-real/list.vue' /* webpackChunkName: "pages/bid2023-real/list" */))
const _5bcde50c = () => interopDefault(import('../pages/branch/businessIncubation/index.vue' /* webpackChunkName: "pages/branch/businessIncubation/index" */))
const _3255fd0c = () => interopDefault(import('../pages/branch/changzhou.vue' /* webpackChunkName: "pages/branch/changzhou" */))
const _6c0afd43 = () => interopDefault(import('../pages/branch/devSearch/index.vue' /* webpackChunkName: "pages/branch/devSearch/index" */))
const _709a5412 = () => interopDefault(import('../pages/branch/policyAdvice.vue' /* webpackChunkName: "pages/branch/policyAdvice" */))
const _c902129a = () => interopDefault(import('../pages/branch/scienceTechnology.vue' /* webpackChunkName: "pages/branch/scienceTechnology" */))
const _57faf672 = () => interopDefault(import('../pages/branch/technicalAchievements/index.vue' /* webpackChunkName: "pages/branch/technicalAchievements/index" */))
const _65f0d92e = () => interopDefault(import('../pages/branch/technicalDemand/index.vue' /* webpackChunkName: "pages/branch/technicalDemand/index" */))
const _09bfec00 = () => interopDefault(import('../pages/branch/technicalManager/index.vue' /* webpackChunkName: "pages/branch/technicalManager/index" */))
const _7d8f5a12 = () => interopDefault(import('../pages/branch/technologyConsulting/index.vue' /* webpackChunkName: "pages/branch/technologyConsulting/index" */))
const _1c99cff8 = () => interopDefault(import('../pages/branch/technologyTransfer.vue' /* webpackChunkName: "pages/branch/technologyTransfer" */))
const _7cb32f28 = () => interopDefault(import('../pages/branch/technologyTransferAgency/index.vue' /* webpackChunkName: "pages/branch/technologyTransferAgency/index" */))
const _5a6dfc70 = () => interopDefault(import('../pages/collegeNew/components/index.js' /* webpackChunkName: "pages/collegeNew/components/index" */))
const _ceadaa82 = () => interopDefault(import('../pages/collegeNew/data.js' /* webpackChunkName: "pages/collegeNew/data" */))
const _4775548b = () => interopDefault(import('../pages/crowdsourcing/data.js' /* webpackChunkName: "pages/crowdsourcing/data" */))
const _2e922a56 = () => interopDefault(import('../pages/crowdsourcing/demandDetail.vue' /* webpackChunkName: "pages/crowdsourcing/demandDetail" */))
const _6bb0eb63 = () => interopDefault(import('../pages/crowdsourcing/demandList.vue' /* webpackChunkName: "pages/crowdsourcing/demandList" */))
const _1f939202 = () => interopDefault(import('../pages/crowdsourcing/resolve.vue' /* webpackChunkName: "pages/crowdsourcing/resolve" */))
const _635c7624 = () => interopDefault(import('../pages/demandDashboard/dashboard.vue' /* webpackChunkName: "pages/demandDashboard/dashboard" */))
const _252d2ff6 = () => interopDefault(import('../pages/finance/detail.vue' /* webpackChunkName: "pages/finance/detail" */))
const _2b9fc216 = () => interopDefault(import('../pages/help/searchResult/index.vue' /* webpackChunkName: "pages/help/searchResult/index" */))
const _d7a22014 = () => interopDefault(import('../pages/help/Sec/index.vue' /* webpackChunkName: "pages/help/Sec/index" */))
const _5d6aea32 = () => interopDefault(import('../pages/help/SecDetail/index.vue' /* webpackChunkName: "pages/help/SecDetail/index" */))
const _07084054 = () => interopDefault(import('../pages/Intermediary/components/index.js' /* webpackChunkName: "pages/Intermediary/components/index" */))
const _4842b1c1 = () => interopDefault(import('../pages/Intermediary/enumCode.js' /* webpackChunkName: "pages/Intermediary/enumCode" */))
const _17a2a1e2 = () => interopDefault(import('../pages/jtop/list.vue' /* webpackChunkName: "pages/jtop/list" */))
const _34d419f6 = () => interopDefault(import('../pages/jtop2021/list.vue' /* webpackChunkName: "pages/jtop2021/list" */))
const _2fe3ea20 = () => interopDefault(import('../pages/jtopTest/list.vue' /* webpackChunkName: "pages/jtopTest/list" */))
const _0fd9d5da = () => interopDefault(import('../pages/laboratory/list.vue' /* webpackChunkName: "pages/laboratory/list" */))
const _4c799be4 = () => interopDefault(import('../pages/lasaDemand/data.js' /* webpackChunkName: "pages/lasaDemand/data" */))
const _0ae75dea = () => interopDefault(import('../pages/lasaDemand/demandList.vue' /* webpackChunkName: "pages/lasaDemand/demandList" */))
const _7cbc0bc2 = () => interopDefault(import('../pages/lasaDemand/demandNewList.vue' /* webpackChunkName: "pages/lasaDemand/demandNewList" */))
const _ffdbd37a = () => interopDefault(import('../pages/lasaDemand/goodsList.vue' /* webpackChunkName: "pages/lasaDemand/goodsList" */))
const _89c71e00 = () => interopDefault(import('../pages/lasaDemand/home.vue' /* webpackChunkName: "pages/lasaDemand/home" */))
const _01b4abf0 = () => interopDefault(import('../pages/measurement/anli/index.vue' /* webpackChunkName: "pages/measurement/anli/index" */))
const _9c01f570 = () => interopDefault(import('../pages/measurement/carrier/index.vue' /* webpackChunkName: "pages/measurement/carrier/index" */))
const _50d818f0 = () => interopDefault(import('../pages/measurement/expert/index.vue' /* webpackChunkName: "pages/measurement/expert/index" */))
const _ffba29bc = () => interopDefault(import('../pages/measurement/home.vue' /* webpackChunkName: "pages/measurement/home" */))
const _0a05ffce = () => interopDefault(import('../pages/measurement/news1/index.vue' /* webpackChunkName: "pages/measurement/news1/index" */))
const _c22a9ae2 = () => interopDefault(import('../pages/measurement/news2/index.vue' /* webpackChunkName: "pages/measurement/news2/index" */))
const _426eddce = () => interopDefault(import('../pages/news/catagory/index.vue' /* webpackChunkName: "pages/news/catagory/index" */))
const _14099bb9 = () => interopDefault(import('../pages/onlineService/analysis.vue' /* webpackChunkName: "pages/onlineService/analysis" */))
const _d08a7232 = () => interopDefault(import('../pages/onlineService/featureList.vue' /* webpackChunkName: "pages/onlineService/featureList" */))
const _2422e32a = () => interopDefault(import('../pages/onlineService/utils.js' /* webpackChunkName: "pages/onlineService/utils" */))
const _3ef11913 = () => interopDefault(import('../pages/overall/data.js' /* webpackChunkName: "pages/overall/data" */))
const _8c5f044a = () => interopDefault(import('../pages/overall/demandList.vue' /* webpackChunkName: "pages/overall/demandList" */))
const _07b81a31 = () => interopDefault(import('../pages/overall/demandNewList.vue' /* webpackChunkName: "pages/overall/demandNewList" */))
const _47f7f862 = () => interopDefault(import('../pages/overall/demandPublish.vue' /* webpackChunkName: "pages/overall/demandPublish" */))
const _179499b1 = () => interopDefault(import('../pages/overall/home.vue' /* webpackChunkName: "pages/overall/home" */))
const _94d2db68 = () => interopDefault(import('../pages/points/pointsGood.vue' /* webpackChunkName: "pages/points/pointsGood" */))
const _d31ee762 = () => interopDefault(import('../pages/points/pointsOrder.vue' /* webpackChunkName: "pages/points/pointsOrder" */))
const _38f91220 = () => interopDefault(import('../pages/points/pointsRecord.vue' /* webpackChunkName: "pages/points/pointsRecord" */))
const _30d751bf = () => interopDefault(import('../pages/screen/demoData.js' /* webpackChunkName: "pages/screen/demoData" */))
const _04423276 = () => interopDefault(import('../pages/screen/drawMixin.js' /* webpackChunkName: "pages/screen/drawMixin" */))
const _27c0f79c = () => interopDefault(import('../pages/screen/screendq.vue' /* webpackChunkName: "pages/screen/screendq" */))
const _2d422600 = () => interopDefault(import('../pages/screen/screengx.vue' /* webpackChunkName: "pages/screen/screengx" */))
const _35d8789c = () => interopDefault(import('../pages/screen/screenly.vue' /* webpackChunkName: "pages/screen/screenly" */))
const _4b96bca7 = () => interopDefault(import('../pages/screen/screenyq.vue' /* webpackChunkName: "pages/screen/screenyq" */))
const _52dc4af9 = () => interopDefault(import('../pages/serviceHall/coreToolDetail.vue' /* webpackChunkName: "pages/serviceHall/coreToolDetail" */))
const _e36fbf58 = () => interopDefault(import('../pages/serviceHall/data.js' /* webpackChunkName: "pages/serviceHall/data" */))
const _9f9b7ef6 = () => interopDefault(import('../pages/serviceHall/serviceDetail.vue' /* webpackChunkName: "pages/serviceHall/serviceDetail" */))
const _6d647a46 = () => interopDefault(import('../pages/sold/demand.vue' /* webpackChunkName: "pages/sold/demand" */))
const _9c5168aa = () => interopDefault(import('../pages/sold/goods.vue' /* webpackChunkName: "pages/sold/goods" */))
const _c7ee9ab0 = () => interopDefault(import('../pages/supplyNew/components/index.js' /* webpackChunkName: "pages/supplyNew/components/index" */))
const _348d1612 = () => interopDefault(import('../pages/supplyNew/data.js' /* webpackChunkName: "pages/supplyNew/data" */))
const _47beac24 = () => interopDefault(import('../pages/talentZone/data.js' /* webpackChunkName: "pages/talentZone/data" */))
const _32dd2ae8 = () => interopDefault(import('../pages/talentZone/detail.vue' /* webpackChunkName: "pages/talentZone/detail" */))
const _eeb82f12 = () => interopDefault(import('../pages/transactionScreen/drawMixin.js' /* webpackChunkName: "pages/transactionScreen/drawMixin" */))
const _18df507c = () => interopDefault(import('../pages/transactionScreen/drawMixin copy.js' /* webpackChunkName: "pages/transactionScreen/drawMixin copy" */))
const _764f2171 = () => interopDefault(import('../pages/tzj2022-real/dqlist.vue' /* webpackChunkName: "pages/tzj2022-real/dqlist" */))
const _8a83bb1e = () => interopDefault(import('../pages/tzj2022-real/lylist.vue' /* webpackChunkName: "pages/tzj2022-real/lylist" */))
const _fd7cd5c2 = () => interopDefault(import('../pages/tzj2022-real/rmlist.vue' /* webpackChunkName: "pages/tzj2022-real/rmlist" */))
const _f92be176 = () => interopDefault(import('../pages/tzj2022-real/stlist.vue' /* webpackChunkName: "pages/tzj2022-real/stlist" */))
const _76e1b2f0 = () => interopDefault(import('../pages/tzj2022/dqlist.vue' /* webpackChunkName: "pages/tzj2022/dqlist" */))
const _08fe2788 = () => interopDefault(import('../pages/tzj2022/lylist.vue' /* webpackChunkName: "pages/tzj2022/lylist" */))
const _60fccb94 = () => interopDefault(import('../pages/tzj2022/rmlist.vue' /* webpackChunkName: "pages/tzj2022/rmlist" */))
const _5cabd748 = () => interopDefault(import('../pages/tzj2022/stlist.vue' /* webpackChunkName: "pages/tzj2022/stlist" */))
const _720e011c = () => interopDefault(import('../pages/tzj2023-real/dqlist.vue' /* webpackChunkName: "pages/tzj2023-real/dqlist" */))
const _0b680072 = () => interopDefault(import('../pages/tzj2023-real/lylist.vue' /* webpackChunkName: "pages/tzj2023-real/lylist" */))
const _5c2919c0 = () => interopDefault(import('../pages/tzj2023-real/rmlist.vue' /* webpackChunkName: "pages/tzj2023-real/rmlist" */))
const _57d82574 = () => interopDefault(import('../pages/tzj2023-real/stlist.vue' /* webpackChunkName: "pages/tzj2023-real/stlist" */))
const _9950a800 = () => interopDefault(import('../pages/yrd-jtop/list.vue' /* webpackChunkName: "pages/yrd-jtop/list" */))
const _1f00c392 = () => interopDefault(import('../pages/yrd/list.vue' /* webpackChunkName: "pages/yrd/list" */))
const _2ea88696 = () => interopDefault(import('../pages/yrd2021/list.vue' /* webpackChunkName: "pages/yrd2021/list" */))
const _4e92367c = () => interopDefault(import('../pages/yrdgoods/list.vue' /* webpackChunkName: "pages/yrdgoods/list" */))
const _213c09e8 = () => interopDefault(import('../pages/yrdgoods/openlist.vue' /* webpackChunkName: "pages/yrdgoods/openlist" */))
const _63664a16 = () => interopDefault(import('../pages/yrdgoods/openlistJs.vue' /* webpackChunkName: "pages/yrdgoods/openlistJs" */))
const _56bd2c30 = () => interopDefault(import('../pages/yrdgoods/openlistNj.vue' /* webpackChunkName: "pages/yrdgoods/openlistNj" */))
const _699fd896 = () => interopDefault(import('../pages/achievement/components/achievementCard.vue' /* webpackChunkName: "pages/achievement/components/achievementCard" */))
const _1a849b78 = () => interopDefault(import('../pages/achievement/components/al-selector.vue' /* webpackChunkName: "pages/achievement/components/al-selector" */))
const _93103644 = () => interopDefault(import('../pages/achievement/components/filter.js' /* webpackChunkName: "pages/achievement/components/filter" */))
const _44ae5d40 = () => interopDefault(import('../pages/achievement/components/firstUseCard.vue' /* webpackChunkName: "pages/achievement/components/firstUseCard" */))
const _dcc12502 = () => interopDefault(import('../pages/achievement/components/kxjsCard.vue' /* webpackChunkName: "pages/achievement/components/kxjsCard" */))
const _c870c654 = () => interopDefault(import('../pages/achievement/components/lyCard.vue' /* webpackChunkName: "pages/achievement/components/lyCard" */))
const _2ae30e00 = () => interopDefault(import('../pages/branch/businessIncubation/filter.vue' /* webpackChunkName: "pages/branch/businessIncubation/filter" */))
const _f1077e42 = () => interopDefault(import('../pages/branch/devSearch/searchFilter.vue' /* webpackChunkName: "pages/branch/devSearch/searchFilter" */))
const _b8b8f152 = () => interopDefault(import('../pages/branch/technologyConsulting/shopDetail.vue' /* webpackChunkName: "pages/branch/technologyConsulting/shopDetail" */))
const _d6a61ecc = () => interopDefault(import('../pages/branch/technologyConsulting/shopDetail/index.vue' /* webpackChunkName: "pages/branch/technologyConsulting/shopDetail/index" */))
const _058192b3 = () => interopDefault(import('../pages/collegeHome/components/myPublish.vue' /* webpackChunkName: "pages/collegeHome/components/myPublish" */))
const _3c7c5ee8 = () => interopDefault(import('../pages/collegeNew/components/achievementCard.vue' /* webpackChunkName: "pages/collegeNew/components/achievementCard" */))
const _a7c60324 = () => interopDefault(import('../pages/collegeNew/components/al-selector.vue' /* webpackChunkName: "pages/collegeNew/components/al-selector" */))
const _22098f58 = () => interopDefault(import('../pages/collegeNew/components/filter.js' /* webpackChunkName: "pages/collegeNew/components/filter" */))
const _0c2cde49 = () => interopDefault(import('../pages/collegeNew/components/kxjsCard.vue' /* webpackChunkName: "pages/collegeNew/components/kxjsCard" */))
const _0944a7ee = () => interopDefault(import('../pages/demandDashboard/components/demandCard.vue' /* webpackChunkName: "pages/demandDashboard/components/demandCard" */))
const _5a3203f8 = () => interopDefault(import('../pages/demandDashboard/components/demandShopCard.vue' /* webpackChunkName: "pages/demandDashboard/components/demandShopCard" */))
const _08001d34 = () => interopDefault(import('../pages/Intermediary/components/achievementCard.vue' /* webpackChunkName: "pages/Intermediary/components/achievementCard" */))
const _1ff19c48 = () => interopDefault(import('../pages/Intermediary/components/al-selector.vue' /* webpackChunkName: "pages/Intermediary/components/al-selector" */))
const _e2ac7ca4 = () => interopDefault(import('../pages/Intermediary/components/filter.js' /* webpackChunkName: "pages/Intermediary/components/filter" */))
const _642e9eaf = () => interopDefault(import('../pages/Intermediary/components/kxjsCard.vue' /* webpackChunkName: "pages/Intermediary/components/kxjsCard" */))
const _3050e929 = () => interopDefault(import('../pages/lasaDemand/components/al-selector.vue' /* webpackChunkName: "pages/lasaDemand/components/al-selector" */))
const _48406b43 = () => interopDefault(import('../pages/lasaDemand/components/demandCard.vue' /* webpackChunkName: "pages/lasaDemand/components/demandCard" */))
const _78388b4f = () => interopDefault(import('../pages/lasaDemand/components/filter.js' /* webpackChunkName: "pages/lasaDemand/components/filter" */))
const _78ef3524 = () => interopDefault(import('../pages/lasaDemand/components/kxjsCard.vue' /* webpackChunkName: "pages/lasaDemand/components/kxjsCard" */))
const _25f2be6f = () => interopDefault(import('../pages/measurement/baseSheshi/largeYiqi/index.vue' /* webpackChunkName: "pages/measurement/baseSheshi/largeYiqi/index" */))
const _5784b6ee = () => interopDefault(import('../pages/measurement/baseSheshi/shiyanshi/index.vue' /* webpackChunkName: "pages/measurement/baseSheshi/shiyanshi/index" */))
const _43b2082f = () => interopDefault(import('../pages/measurement/chengguo/guifan/index.vue' /* webpackChunkName: "pages/measurement/chengguo/guifan/index" */))
const _ca1feca0 = () => interopDefault(import('../pages/measurement/chengguo/xianjin/index.vue' /* webpackChunkName: "pages/measurement/chengguo/xianjin/index" */))
const _a5bbd9d0 = () => interopDefault(import('../pages/measurement/components/five.vue' /* webpackChunkName: "pages/measurement/components/five" */))
const _2cec60e8 = () => interopDefault(import('../pages/measurement/components/four.vue' /* webpackChunkName: "pages/measurement/components/four" */))
const _ab037666 = () => interopDefault(import('../pages/measurement/components/myPublish.vue' /* webpackChunkName: "pages/measurement/components/myPublish" */))
const _b51fd494 = () => interopDefault(import('../pages/measurement/components/myPublish3.vue' /* webpackChunkName: "pages/measurement/components/myPublish3" */))
const _a13fcd20 = () => interopDefault(import('../pages/measurement/components/one.vue' /* webpackChunkName: "pages/measurement/components/one" */))
const _3b0b29d2 = () => interopDefault(import('../pages/measurement/components/seven.vue' /* webpackChunkName: "pages/measurement/components/seven" */))
const _7b7c89ec = () => interopDefault(import('../pages/measurement/components/six.vue' /* webpackChunkName: "pages/measurement/components/six" */))
const _4b6abfb0 = () => interopDefault(import('../pages/measurement/components/three.vue' /* webpackChunkName: "pages/measurement/components/three" */))
const _70706b54 = () => interopDefault(import('../pages/measurement/components/two.vue' /* webpackChunkName: "pages/measurement/components/two" */))
const _102ac768 = () => interopDefault(import('../pages/onlineService/components/AiChat.vue' /* webpackChunkName: "pages/onlineService/components/AiChat" */))
const _2d5e98b4 = () => interopDefault(import('../pages/onlineService/components/AllFunctions.vue' /* webpackChunkName: "pages/onlineService/components/AllFunctions" */))
const _3c262a76 = () => interopDefault(import('../pages/onlineService/components/Historical.vue' /* webpackChunkName: "pages/onlineService/components/Historical" */))
const _05aa57ac = () => interopDefault(import('../pages/onlineService/components/HList.vue' /* webpackChunkName: "pages/onlineService/components/HList" */))
const _78886fea = () => interopDefault(import('../pages/onlineService/components/RelatedWords.vue' /* webpackChunkName: "pages/onlineService/components/RelatedWords" */))
const _917554da = () => interopDefault(import('../pages/onlineService/components/RightNav.vue' /* webpackChunkName: "pages/onlineService/components/RightNav" */))
const _53163587 = () => interopDefault(import('../pages/onlineService/components/SearchBox.vue' /* webpackChunkName: "pages/onlineService/components/SearchBox" */))
const _062f6444 = () => interopDefault(import('../pages/onlineService/components/SmartMatchResults.vue' /* webpackChunkName: "pages/onlineService/components/SmartMatchResults" */))
const _35a29d88 = () => interopDefault(import('../pages/onlineService/components/TechnicalManager.vue' /* webpackChunkName: "pages/onlineService/components/TechnicalManager" */))
const _30dca79a = () => interopDefault(import('../pages/overall/components/al-selector.vue' /* webpackChunkName: "pages/overall/components/al-selector" */))
const _1efa9ab2 = () => interopDefault(import('../pages/overall/components/demandCard.vue' /* webpackChunkName: "pages/overall/components/demandCard" */))
const _1d090dd4 = () => interopDefault(import('../pages/roadShow/components/activityCard.vue' /* webpackChunkName: "pages/roadShow/components/activityCard" */))
const _8de1948e = () => interopDefault(import('../pages/screen/components/collegeLeft1.vue' /* webpackChunkName: "pages/screen/components/collegeLeft1" */))
const _8dc5658c = () => interopDefault(import('../pages/screen/components/collegeLeft2.vue' /* webpackChunkName: "pages/screen/components/collegeLeft2" */))
const _8da9368a = () => interopDefault(import('../pages/screen/components/collegeLeft3.vue' /* webpackChunkName: "pages/screen/components/collegeLeft3" */))
const _f6aa79ec = () => interopDefault(import('../pages/screen/components/collegeMid1.vue' /* webpackChunkName: "pages/screen/components/collegeMid1" */))
const _f68e4aea = () => interopDefault(import('../pages/screen/components/collegeMid2.vue' /* webpackChunkName: "pages/screen/components/collegeMid2" */))
const _f6721be8 = () => interopDefault(import('../pages/screen/components/collegeMid3.vue' /* webpackChunkName: "pages/screen/components/collegeMid3" */))
const _59d2e514 = () => interopDefault(import('../pages/screen/components/collegeRight1.vue' /* webpackChunkName: "pages/screen/components/collegeRight1" */))
const _59b6b612 = () => interopDefault(import('../pages/screen/components/collegeRight2.vue' /* webpackChunkName: "pages/screen/components/collegeRight2" */))
const _599a8710 = () => interopDefault(import('../pages/screen/components/collegeRight3.vue' /* webpackChunkName: "pages/screen/components/collegeRight3" */))
const _18889bed = () => interopDefault(import('../pages/screen/components/fieldMid1.vue' /* webpackChunkName: "pages/screen/components/fieldMid1" */))
const _18a4caef = () => interopDefault(import('../pages/screen/components/fieldMid3.vue' /* webpackChunkName: "pages/screen/components/fieldMid3" */))
const _0c8a1fb3 = () => interopDefault(import('../pages/screen/components/itemMap.vue' /* webpackChunkName: "pages/screen/components/itemMap" */))
const _f65cffe2 = () => interopDefault(import('../pages/screen/components/itemMap2.vue' /* webpackChunkName: "pages/screen/components/itemMap2" */))
const _f640d0e0 = () => interopDefault(import('../pages/screen/components/itemMap3.vue' /* webpackChunkName: "pages/screen/components/itemMap3" */))
const _13200838 = () => interopDefault(import('../pages/screen/components/table.vue' /* webpackChunkName: "pages/screen/components/table" */))
const _cd70c6bc = () => interopDefault(import('../pages/screen/components/toolTip.js' /* webpackChunkName: "pages/screen/components/toolTip" */))
const _73fbcb91 = () => interopDefault(import('../pages/screen/directive/dateTime.js' /* webpackChunkName: "pages/screen/directive/dateTime" */))
const _ae796158 = () => interopDefault(import('../pages/screen/directive/demandArea.js' /* webpackChunkName: "pages/screen/directive/demandArea" */))
const _29c3f970 = () => interopDefault(import('../pages/screen/directive/directives.js' /* webpackChunkName: "pages/screen/directive/directives" */))
const _60f1e013 = () => interopDefault(import('../pages/screen/directive/eight.js' /* webpackChunkName: "pages/screen/directive/eight" */))
const _4799435c = () => interopDefault(import('../pages/screen/directive/first.js' /* webpackChunkName: "pages/screen/directive/first" */))
const _758a28cc = () => interopDefault(import('../pages/screen/directive/five.js' /* webpackChunkName: "pages/screen/directive/five" */))
const _61205eb4 = () => interopDefault(import('../pages/screen/directive/four.js' /* webpackChunkName: "pages/screen/directive/four" */))
const _6bfc099a = () => interopDefault(import('../pages/screen/directive/nine.js' /* webpackChunkName: "pages/screen/directive/nine" */))
const _719f9d58 = () => interopDefault(import('../pages/screen/directive/second.js' /* webpackChunkName: "pages/screen/directive/second" */))
const _551517d5 = () => interopDefault(import('../pages/screen/directive/seven.js' /* webpackChunkName: "pages/screen/directive/seven" */))
const _f03294c0 = () => interopDefault(import('../pages/screen/directive/six.js' /* webpackChunkName: "pages/screen/directive/six" */))
const _ed42b6f6 = () => interopDefault(import('../pages/screen/directive/ten.js' /* webpackChunkName: "pages/screen/directive/ten" */))
const _54d17ca4 = () => interopDefault(import('../pages/screen/directive/three.js' /* webpackChunkName: "pages/screen/directive/three" */))
const _76558754 = () => interopDefault(import('../pages/supplyNew/components/achievementCard.vue' /* webpackChunkName: "pages/supplyNew/components/achievementCard" */))
const _186b5936 = () => interopDefault(import('../pages/supplyNew/components/al-selector.vue' /* webpackChunkName: "pages/supplyNew/components/al-selector" */))
const _60414596 = () => interopDefault(import('../pages/supplyNew/components/demandCard.vue' /* webpackChunkName: "pages/supplyNew/components/demandCard" */))
const _3e916dc8 = () => interopDefault(import('../pages/supplyNew/components/filter.js' /* webpackChunkName: "pages/supplyNew/components/filter" */))
const _0edc8efe = () => interopDefault(import('../pages/supplyNew/components/kxjsCard.vue' /* webpackChunkName: "pages/supplyNew/components/kxjsCard" */))
const _75490f5a = () => interopDefault(import('../pages/supplyNew/components/serviceCard.vue' /* webpackChunkName: "pages/supplyNew/components/serviceCard" */))
const _1aa8ded2 = () => interopDefault(import('../pages/measurement/baseSheshi/largeYiqi/_id.vue' /* webpackChunkName: "pages/measurement/baseSheshi/largeYiqi/_id" */))
const _2d0f9cd6 = () => interopDefault(import('../pages/measurement/baseSheshi/shiyanshi/_id.vue' /* webpackChunkName: "pages/measurement/baseSheshi/shiyanshi/_id" */))
const _17324a57 = () => interopDefault(import('../pages/measurement/chengguo/guifan/_id.vue' /* webpackChunkName: "pages/measurement/chengguo/guifan/_id" */))
const _6d54b818 = () => interopDefault(import('../pages/measurement/chengguo/xianjin/_id.vue' /* webpackChunkName: "pages/measurement/chengguo/xianjin/_id" */))
const _339e99eb = () => interopDefault(import('../pages/technicalContractsRegistration/list/detail/_id.vue' /* webpackChunkName: "pages/technicalContractsRegistration/list/detail/_id" */))
const _ecbfb33c = () => interopDefault(import('../pages/branch/businessIncubation/_id.vue' /* webpackChunkName: "pages/branch/businessIncubation/_id" */))
const _1ca5172a = () => interopDefault(import('../pages/branch/devSearch/_id.vue' /* webpackChunkName: "pages/branch/devSearch/_id" */))
const _ebade622 = () => interopDefault(import('../pages/branch/technicalAchievements/_id.vue' /* webpackChunkName: "pages/branch/technicalAchievements/_id" */))
const _abf78994 = () => interopDefault(import('../pages/branch/technicalDemand/_Id.vue' /* webpackChunkName: "pages/branch/technicalDemand/_Id" */))
const _19aee730 = () => interopDefault(import('../pages/branch/technicalManager/_id.vue' /* webpackChunkName: "pages/branch/technicalManager/_id" */))
const _60779758 = () => interopDefault(import('../pages/measurement/expert/_id.vue' /* webpackChunkName: "pages/measurement/expert/_id" */))
const _670d9db6 = () => interopDefault(import('../pages/measurement/news1/_id.vue' /* webpackChunkName: "pages/measurement/news1/_id" */))
const _095be692 = () => interopDefault(import('../pages/measurement/news2/_id.vue' /* webpackChunkName: "pages/measurement/news2/_id" */))
const _fa54a476 = () => interopDefault(import('../pages/technicalContractsRegistration/download/_id.vue' /* webpackChunkName: "pages/technicalContractsRegistration/download/_id" */))
const _12eeacdb = () => interopDefault(import('../pages/technicalContractsRegistration/list/_id.vue' /* webpackChunkName: "pages/technicalContractsRegistration/list/_id" */))
const _48bb68c4 = () => interopDefault(import('../pages/antincp/_id.vue' /* webpackChunkName: "pages/antincp/_id" */))
const _3eb7e3d6 = () => interopDefault(import('../pages/collegeNews/_id.vue' /* webpackChunkName: "pages/collegeNews/_id" */))
const _b49616b6 = () => interopDefault(import('../pages/expert/_id.vue' /* webpackChunkName: "pages/expert/_id" */))
const _70e8012e = () => interopDefault(import('../pages/laboratory/_id.vue' /* webpackChunkName: "pages/laboratory/_id" */))
const _50a9a129 = () => interopDefault(import('../pages/lasaDemand/_id.vue' /* webpackChunkName: "pages/lasaDemand/_id" */))
const _4a6af364 = () => interopDefault(import('../pages/news/_id.vue' /* webpackChunkName: "pages/news/_id" */))
const _43211e58 = () => interopDefault(import('../pages/overall/_id.vue' /* webpackChunkName: "pages/overall/_id" */))
const _3e9cf9b0 = () => interopDefault(import('../pages/publicity/_id.vue' /* webpackChunkName: "pages/publicity/_id" */))
const _e542f99c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _40b0075c,
    name: "achievement"
  }, {
    path: "/activity",
    component: _e57ad8bc,
    name: "activity"
  }, {
    path: "/antincp",
    component: _376d3f5c,
    name: "antincp"
  }, {
    path: "/assetSingleChengguo",
    component: _106690ba,
    name: "assetSingleChengguo"
  }, {
    path: "/bearer",
    component: _3f0e9374,
    name: "bearer"
  }, {
    path: "/bearerJS",
    component: _63d4a33d,
    name: "bearerJS"
  }, {
    path: "/bearerNj",
    component: _39b16fe0,
    name: "bearerNj"
  }, {
    path: "/bid2021",
    component: _1adc9add,
    name: "bid2021"
  }, {
    path: "/bid2022",
    component: _a07d64c4,
    name: "bid2022"
  }, {
    path: "/bid2022-real",
    component: _107d3403,
    name: "bid2022-real"
  }, {
    path: "/bid2023-real",
    component: _1be1dc3c,
    name: "bid2023-real"
  }, {
    path: "/branch",
    component: _34d49875,
    name: "branch"
  }, {
    path: "/college",
    component: _312ede8c,
    name: "college"
  }, {
    path: "/collegeActivity",
    component: _d6da2bae,
    name: "collegeActivity"
  }, {
    path: "/collegeChengguo",
    component: _5882e422,
    name: "collegeChengguo"
  }, {
    path: "/collegeHome",
    component: _0c3b1f79,
    name: "collegeHome"
  }, {
    path: "/collegeList",
    component: _379f0f10,
    name: "collegeList"
  }, {
    path: "/collegeMien",
    component: _4609f342,
    name: "collegeMien"
  }, {
    path: "/collegeNew",
    component: _099392c8,
    name: "collegeNew"
  }, {
    path: "/collegeNews",
    component: _77c1d46d,
    name: "collegeNews"
  }, {
    path: "/collegeSearch",
    component: _441e5542,
    name: "collegeSearch"
  }, {
    path: "/crowdsourcing",
    component: _279f1d68,
    name: "crowdsourcing"
  }, {
    path: "/demand",
    component: _3abd4444,
    name: "demand"
  }, {
    path: "/demandDashboard",
    component: _af4035a8,
    name: "demandDashboard"
  }, {
    path: "/demo",
    component: _30d96d33,
    name: "demo"
  }, {
    path: "/dqxqLb",
    component: _f37de2a2,
    name: "dqxqLb"
  }, {
    path: "/ecoBlank",
    component: _24544854,
    name: "ecoBlank"
  }, {
    path: "/ecoServices",
    component: _00561f9c,
    name: "ecoServices"
  }, {
    path: "/expert",
    component: _3c3356fd,
    name: "expert"
  }, {
    path: "/finance",
    component: _5a027186,
    name: "finance"
  }, {
    path: "/forgetpwd",
    component: _3813e013,
    name: "forgetpwd"
  }, {
    path: "/goods",
    component: _459375b9,
    name: "goods"
  }, {
    path: "/goods1",
    component: _1616632e,
    name: "goods1"
  }, {
    path: "/help",
    component: _23a83554,
    name: "help"
  }, {
    path: "/Intermediary",
    component: _ebfffcfc,
    name: "Intermediary"
  }, {
    path: "/jtop",
    component: _0fb3cb84,
    name: "jtop"
  }, {
    path: "/jtop2021",
    component: _2ec6250a,
    name: "jtop2021"
  }, {
    path: "/jtopTest",
    component: _3527d2f0,
    name: "jtopTest"
  }, {
    path: "/laboratory",
    component: _06d56546,
    name: "laboratory"
  }, {
    path: "/listed",
    component: _104b5ad0,
    name: "listed"
  }, {
    path: "/login",
    component: _5e75dbe8,
    name: "login"
  }, {
    path: "/loginThird",
    component: _8342595e,
    name: "loginThird"
  }, {
    path: "/manageList",
    component: _a0a55d94,
    name: "manageList"
  }, {
    path: "/news",
    component: _fba9bb34,
    name: "news"
  }, {
    path: "/onlineService",
    component: _593c8c45,
    name: "onlineService"
  }, {
    path: "/points",
    component: _74ca7276,
    name: "points"
  }, {
    path: "/presentationDemand",
    component: _7ae79918,
    name: "presentationDemand"
  }, {
    path: "/publicity",
    component: _3b2e4548,
    name: "publicity"
  }, {
    path: "/register",
    component: _47873394,
    name: "register"
  }, {
    path: "/report",
    component: _5670f987,
    name: "report"
  }, {
    path: "/rmxqLb",
    component: _74cd87dd,
    name: "rmxqLb"
  }, {
    path: "/roadShow",
    component: _78958560,
    name: "roadShow"
  }, {
    path: "/search",
    component: _596c08fb,
    name: "search"
  }, {
    path: "/serviceGuide",
    component: _7a32684c,
    name: "serviceGuide"
  }, {
    path: "/serviceHall",
    component: _04ee1af1,
    name: "serviceHall"
  }, {
    path: "/shop",
    component: _2d94ee74,
    children: [{
      path: "",
      component: _8a643a6e,
      name: "shop"
    }, {
      path: "index2",
      component: _c1f3c08e,
      name: "shop-index2"
    }, {
      path: "indexCopy",
      component: _13f2b35e,
      name: "shop-indexCopy"
    }, {
      path: "orgAnalysis",
      component: _1c04a197,
      name: "shop-orgAnalysis"
    }, {
      path: "shopGoods",
      component: _fea33d12,
      name: "shop-shopGoods"
    }, {
      path: "shopGoods2",
      component: _d595126a,
      name: "shop-shopGoods2"
    }]
  }, {
    path: "/shop2",
    component: _3d93395c,
    name: "shop2"
  }, {
    path: "/shopCopy",
    component: _4c25da4a,
    name: "shopCopy"
  }, {
    path: "/statement",
    component: _360f5892,
    name: "statement"
  }, {
    path: "/stzqLb",
    component: _e1ca3e7e,
    name: "stzqLb"
  }, {
    path: "/supply",
    component: _7e8a1f82,
    name: "supply"
  }, {
    path: "/supply1",
    component: _08161af6,
    name: "supply1"
  }, {
    path: "/supplyNew",
    component: _455cd2d4,
    name: "supplyNew"
  }, {
    path: "/talentZone",
    component: _3ecaa60b,
    name: "talentZone"
  }, {
    path: "/technicalContractsRegistration",
    component: _3805eeb0,
    name: "technicalContractsRegistration"
  }, {
    path: "/technologicalAchievement",
    component: _4025c590,
    name: "technologicalAchievement"
  }, {
    path: "/test",
    component: _437bf965,
    name: "test"
  }, {
    path: "/thirdPartyAuth",
    component: _2d5c089a,
    name: "thirdPartyAuth"
  }, {
    path: "/transactionScreen",
    component: _355f6a4d,
    name: "transactionScreen"
  }, {
    path: "/tzj2021",
    component: _46bb1f78,
    name: "tzj2021"
  }, {
    path: "/tzj2022",
    component: _71872305,
    name: "tzj2022"
  }, {
    path: "/tzj2022-real",
    component: _6c50b208,
    name: "tzj2022-real"
  }, {
    path: "/tzj2023-real",
    component: _a92cf64a,
    name: "tzj2023-real"
  }, {
    path: "/yrd",
    component: _46e7a2e4,
    name: "yrd"
  }, {
    path: "/yrd-jtop",
    component: _59db5840,
    name: "yrd-jtop"
  }, {
    path: "/yrd2021",
    component: _484059cb,
    name: "yrd2021"
  }, {
    path: "/yrdgoods",
    component: _599a335e,
    name: "yrdgoods"
  }, {
    path: "/zdlyLb",
    component: _36587b20,
    name: "zdlyLb"
  }, {
    path: "/achievement/achievementDetail",
    component: _5a97f4e0,
    name: "achievement-achievementDetail"
  }, {
    path: "/achievement/achievementList",
    component: _92485f26,
    name: "achievement-achievementList"
  }, {
    path: "/achievement/components",
    component: _0476d2b4,
    name: "achievement-components"
  }, {
    path: "/activity/activityDetail",
    component: _34c530a0,
    name: "activity-activityDetail"
  }, {
    path: "/bearer/list",
    component: _d469ac28,
    name: "bearer-list"
  }, {
    path: "/bid2021/list",
    component: _7bda1163,
    name: "bid2021-list"
  }, {
    path: "/bid2022-real/list",
    component: _b6628906,
    name: "bid2022-real-list"
  }, {
    path: "/bid2022/list",
    component: _70238282,
    name: "bid2022-list"
  }, {
    path: "/bid2023-real/list",
    component: _02abb484,
    name: "bid2023-real-list"
  }, {
    path: "/branch/businessIncubation",
    component: _5bcde50c,
    name: "branch-businessIncubation"
  }, {
    path: "/branch/changzhou",
    component: _3255fd0c,
    name: "branch-changzhou"
  }, {
    path: "/branch/devSearch",
    component: _6c0afd43,
    name: "branch-devSearch"
  }, {
    path: "/branch/policyAdvice",
    component: _709a5412,
    name: "branch-policyAdvice"
  }, {
    path: "/branch/scienceTechnology",
    component: _c902129a,
    name: "branch-scienceTechnology"
  }, {
    path: "/branch/technicalAchievements",
    component: _57faf672,
    name: "branch-technicalAchievements"
  }, {
    path: "/branch/technicalDemand",
    component: _65f0d92e,
    name: "branch-technicalDemand"
  }, {
    path: "/branch/technicalManager",
    component: _09bfec00,
    name: "branch-technicalManager"
  }, {
    path: "/branch/technologyConsulting",
    component: _7d8f5a12,
    name: "branch-technologyConsulting"
  }, {
    path: "/branch/technologyTransfer",
    component: _1c99cff8,
    name: "branch-technologyTransfer"
  }, {
    path: "/branch/technologyTransferAgency",
    component: _7cb32f28,
    name: "branch-technologyTransferAgency"
  }, {
    path: "/collegeNew/components",
    component: _5a6dfc70,
    name: "collegeNew-components"
  }, {
    path: "/collegeNew/data",
    component: _ceadaa82,
    name: "collegeNew-data"
  }, {
    path: "/crowdsourcing/data",
    component: _4775548b,
    name: "crowdsourcing-data"
  }, {
    path: "/crowdsourcing/demandDetail",
    component: _2e922a56,
    name: "crowdsourcing-demandDetail"
  }, {
    path: "/crowdsourcing/demandList",
    component: _6bb0eb63,
    name: "crowdsourcing-demandList"
  }, {
    path: "/crowdsourcing/resolve",
    component: _1f939202,
    name: "crowdsourcing-resolve"
  }, {
    path: "/demandDashboard/dashboard",
    component: _635c7624,
    name: "demandDashboard-dashboard"
  }, {
    path: "/finance/detail",
    component: _252d2ff6,
    name: "finance-detail"
  }, {
    path: "/help/searchResult",
    component: _2b9fc216,
    name: "help-searchResult"
  }, {
    path: "/help/Sec",
    component: _d7a22014,
    name: "help-Sec"
  }, {
    path: "/help/SecDetail",
    component: _5d6aea32,
    name: "help-SecDetail"
  }, {
    path: "/Intermediary/components",
    component: _07084054,
    name: "Intermediary-components"
  }, {
    path: "/Intermediary/enumCode",
    component: _4842b1c1,
    name: "Intermediary-enumCode"
  }, {
    path: "/jtop/list",
    component: _17a2a1e2,
    name: "jtop-list"
  }, {
    path: "/jtop2021/list",
    component: _34d419f6,
    name: "jtop2021-list"
  }, {
    path: "/jtopTest/list",
    component: _2fe3ea20,
    name: "jtopTest-list"
  }, {
    path: "/laboratory/list",
    component: _0fd9d5da,
    name: "laboratory-list"
  }, {
    path: "/lasaDemand/data",
    component: _4c799be4,
    name: "lasaDemand-data"
  }, {
    path: "/lasaDemand/demandList",
    component: _0ae75dea,
    name: "lasaDemand-demandList"
  }, {
    path: "/lasaDemand/demandNewList",
    component: _7cbc0bc2,
    name: "lasaDemand-demandNewList"
  }, {
    path: "/lasaDemand/goodsList",
    component: _ffdbd37a,
    name: "lasaDemand-goodsList"
  }, {
    path: "/lasaDemand/home",
    component: _89c71e00,
    name: "lasaDemand-home"
  }, {
    path: "/measurement/anli",
    component: _01b4abf0,
    name: "measurement-anli"
  }, {
    path: "/measurement/carrier",
    component: _9c01f570,
    name: "measurement-carrier"
  }, {
    path: "/measurement/expert",
    component: _50d818f0,
    name: "measurement-expert"
  }, {
    path: "/measurement/home",
    component: _ffba29bc,
    name: "measurement-home"
  }, {
    path: "/measurement/news1",
    component: _0a05ffce,
    name: "measurement-news1"
  }, {
    path: "/measurement/news2",
    component: _c22a9ae2,
    name: "measurement-news2"
  }, {
    path: "/news/catagory",
    component: _426eddce,
    name: "news-catagory"
  }, {
    path: "/onlineService/analysis",
    component: _14099bb9,
    name: "onlineService-analysis"
  }, {
    path: "/onlineService/featureList",
    component: _d08a7232,
    name: "onlineService-featureList"
  }, {
    path: "/onlineService/utils",
    component: _2422e32a,
    name: "onlineService-utils"
  }, {
    path: "/overall/data",
    component: _3ef11913,
    name: "overall-data"
  }, {
    path: "/overall/demandList",
    component: _8c5f044a,
    name: "overall-demandList"
  }, {
    path: "/overall/demandNewList",
    component: _07b81a31,
    name: "overall-demandNewList"
  }, {
    path: "/overall/demandPublish",
    component: _47f7f862,
    name: "overall-demandPublish"
  }, {
    path: "/overall/home",
    component: _179499b1,
    name: "overall-home"
  }, {
    path: "/points/pointsGood",
    component: _94d2db68,
    name: "points-pointsGood"
  }, {
    path: "/points/pointsOrder",
    component: _d31ee762,
    name: "points-pointsOrder"
  }, {
    path: "/points/pointsRecord",
    component: _38f91220,
    name: "points-pointsRecord"
  }, {
    path: "/screen/demoData",
    component: _30d751bf,
    name: "screen-demoData"
  }, {
    path: "/screen/drawMixin",
    component: _04423276,
    name: "screen-drawMixin"
  }, {
    path: "/screen/screendq",
    component: _27c0f79c,
    name: "screen-screendq"
  }, {
    path: "/screen/screengx",
    component: _2d422600,
    name: "screen-screengx"
  }, {
    path: "/screen/screenly",
    component: _35d8789c,
    name: "screen-screenly"
  }, {
    path: "/screen/screenyq",
    component: _4b96bca7,
    name: "screen-screenyq"
  }, {
    path: "/serviceHall/coreToolDetail",
    component: _52dc4af9,
    name: "serviceHall-coreToolDetail"
  }, {
    path: "/serviceHall/data",
    component: _e36fbf58,
    name: "serviceHall-data"
  }, {
    path: "/serviceHall/serviceDetail",
    component: _9f9b7ef6,
    name: "serviceHall-serviceDetail"
  }, {
    path: "/sold/demand",
    component: _6d647a46,
    name: "sold-demand"
  }, {
    path: "/sold/goods",
    component: _9c5168aa,
    name: "sold-goods"
  }, {
    path: "/supplyNew/components",
    component: _c7ee9ab0,
    name: "supplyNew-components"
  }, {
    path: "/supplyNew/data",
    component: _348d1612,
    name: "supplyNew-data"
  }, {
    path: "/talentZone/data",
    component: _47beac24,
    name: "talentZone-data"
  }, {
    path: "/talentZone/detail",
    component: _32dd2ae8,
    name: "talentZone-detail"
  }, {
    path: "/transactionScreen/drawMixin",
    component: _eeb82f12,
    name: "transactionScreen-drawMixin"
  }, {
    path: "/transactionScreen/drawMixin copy",
    component: _18df507c,
    name: "transactionScreen-drawMixin copy"
  }, {
    path: "/tzj2022-real/dqlist",
    component: _764f2171,
    name: "tzj2022-real-dqlist"
  }, {
    path: "/tzj2022-real/lylist",
    component: _8a83bb1e,
    name: "tzj2022-real-lylist"
  }, {
    path: "/tzj2022-real/rmlist",
    component: _fd7cd5c2,
    name: "tzj2022-real-rmlist"
  }, {
    path: "/tzj2022-real/stlist",
    component: _f92be176,
    name: "tzj2022-real-stlist"
  }, {
    path: "/tzj2022/dqlist",
    component: _76e1b2f0,
    name: "tzj2022-dqlist"
  }, {
    path: "/tzj2022/lylist",
    component: _08fe2788,
    name: "tzj2022-lylist"
  }, {
    path: "/tzj2022/rmlist",
    component: _60fccb94,
    name: "tzj2022-rmlist"
  }, {
    path: "/tzj2022/stlist",
    component: _5cabd748,
    name: "tzj2022-stlist"
  }, {
    path: "/tzj2023-real/dqlist",
    component: _720e011c,
    name: "tzj2023-real-dqlist"
  }, {
    path: "/tzj2023-real/lylist",
    component: _0b680072,
    name: "tzj2023-real-lylist"
  }, {
    path: "/tzj2023-real/rmlist",
    component: _5c2919c0,
    name: "tzj2023-real-rmlist"
  }, {
    path: "/tzj2023-real/stlist",
    component: _57d82574,
    name: "tzj2023-real-stlist"
  }, {
    path: "/yrd-jtop/list",
    component: _9950a800,
    name: "yrd-jtop-list"
  }, {
    path: "/yrd/list",
    component: _1f00c392,
    name: "yrd-list"
  }, {
    path: "/yrd2021/list",
    component: _2ea88696,
    name: "yrd2021-list"
  }, {
    path: "/yrdgoods/list",
    component: _4e92367c,
    name: "yrdgoods-list"
  }, {
    path: "/yrdgoods/openlist",
    component: _213c09e8,
    name: "yrdgoods-openlist"
  }, {
    path: "/yrdgoods/openlistJs",
    component: _63664a16,
    name: "yrdgoods-openlistJs"
  }, {
    path: "/yrdgoods/openlistNj",
    component: _56bd2c30,
    name: "yrdgoods-openlistNj"
  }, {
    path: "/achievement/components/achievementCard",
    component: _699fd896,
    name: "achievement-components-achievementCard"
  }, {
    path: "/achievement/components/al-selector",
    component: _1a849b78,
    name: "achievement-components-al-selector"
  }, {
    path: "/achievement/components/filter",
    component: _93103644,
    name: "achievement-components-filter"
  }, {
    path: "/achievement/components/firstUseCard",
    component: _44ae5d40,
    name: "achievement-components-firstUseCard"
  }, {
    path: "/achievement/components/kxjsCard",
    component: _dcc12502,
    name: "achievement-components-kxjsCard"
  }, {
    path: "/achievement/components/lyCard",
    component: _c870c654,
    name: "achievement-components-lyCard"
  }, {
    path: "/branch/businessIncubation/filter",
    component: _2ae30e00,
    name: "branch-businessIncubation-filter"
  }, {
    path: "/branch/devSearch/searchFilter",
    component: _f1077e42,
    name: "branch-devSearch-searchFilter"
  }, {
    path: "/branch/technologyConsulting/shopDetail",
    component: _b8b8f152,
    children: [{
      path: "",
      component: _d6a61ecc,
      name: "branch-technologyConsulting-shopDetail"
    }]
  }, {
    path: "/collegeHome/components/myPublish",
    component: _058192b3,
    name: "collegeHome-components-myPublish"
  }, {
    path: "/collegeNew/components/achievementCard",
    component: _3c7c5ee8,
    name: "collegeNew-components-achievementCard"
  }, {
    path: "/collegeNew/components/al-selector",
    component: _a7c60324,
    name: "collegeNew-components-al-selector"
  }, {
    path: "/collegeNew/components/filter",
    component: _22098f58,
    name: "collegeNew-components-filter"
  }, {
    path: "/collegeNew/components/kxjsCard",
    component: _0c2cde49,
    name: "collegeNew-components-kxjsCard"
  }, {
    path: "/demandDashboard/components/demandCard",
    component: _0944a7ee,
    name: "demandDashboard-components-demandCard"
  }, {
    path: "/demandDashboard/components/demandShopCard",
    component: _5a3203f8,
    name: "demandDashboard-components-demandShopCard"
  }, {
    path: "/Intermediary/components/achievementCard",
    component: _08001d34,
    name: "Intermediary-components-achievementCard"
  }, {
    path: "/Intermediary/components/al-selector",
    component: _1ff19c48,
    name: "Intermediary-components-al-selector"
  }, {
    path: "/Intermediary/components/filter",
    component: _e2ac7ca4,
    name: "Intermediary-components-filter"
  }, {
    path: "/Intermediary/components/kxjsCard",
    component: _642e9eaf,
    name: "Intermediary-components-kxjsCard"
  }, {
    path: "/lasaDemand/components/al-selector",
    component: _3050e929,
    name: "lasaDemand-components-al-selector"
  }, {
    path: "/lasaDemand/components/demandCard",
    component: _48406b43,
    name: "lasaDemand-components-demandCard"
  }, {
    path: "/lasaDemand/components/filter",
    component: _78388b4f,
    name: "lasaDemand-components-filter"
  }, {
    path: "/lasaDemand/components/kxjsCard",
    component: _78ef3524,
    name: "lasaDemand-components-kxjsCard"
  }, {
    path: "/measurement/baseSheshi/largeYiqi",
    component: _25f2be6f,
    name: "measurement-baseSheshi-largeYiqi"
  }, {
    path: "/measurement/baseSheshi/shiyanshi",
    component: _5784b6ee,
    name: "measurement-baseSheshi-shiyanshi"
  }, {
    path: "/measurement/chengguo/guifan",
    component: _43b2082f,
    name: "measurement-chengguo-guifan"
  }, {
    path: "/measurement/chengguo/xianjin",
    component: _ca1feca0,
    name: "measurement-chengguo-xianjin"
  }, {
    path: "/measurement/components/five",
    component: _a5bbd9d0,
    name: "measurement-components-five"
  }, {
    path: "/measurement/components/four",
    component: _2cec60e8,
    name: "measurement-components-four"
  }, {
    path: "/measurement/components/myPublish",
    component: _ab037666,
    name: "measurement-components-myPublish"
  }, {
    path: "/measurement/components/myPublish3",
    component: _b51fd494,
    name: "measurement-components-myPublish3"
  }, {
    path: "/measurement/components/one",
    component: _a13fcd20,
    name: "measurement-components-one"
  }, {
    path: "/measurement/components/seven",
    component: _3b0b29d2,
    name: "measurement-components-seven"
  }, {
    path: "/measurement/components/six",
    component: _7b7c89ec,
    name: "measurement-components-six"
  }, {
    path: "/measurement/components/three",
    component: _4b6abfb0,
    name: "measurement-components-three"
  }, {
    path: "/measurement/components/two",
    component: _70706b54,
    name: "measurement-components-two"
  }, {
    path: "/onlineService/components/AiChat",
    component: _102ac768,
    name: "onlineService-components-AiChat"
  }, {
    path: "/onlineService/components/AllFunctions",
    component: _2d5e98b4,
    name: "onlineService-components-AllFunctions"
  }, {
    path: "/onlineService/components/Historical",
    component: _3c262a76,
    name: "onlineService-components-Historical"
  }, {
    path: "/onlineService/components/HList",
    component: _05aa57ac,
    name: "onlineService-components-HList"
  }, {
    path: "/onlineService/components/RelatedWords",
    component: _78886fea,
    name: "onlineService-components-RelatedWords"
  }, {
    path: "/onlineService/components/RightNav",
    component: _917554da,
    name: "onlineService-components-RightNav"
  }, {
    path: "/onlineService/components/SearchBox",
    component: _53163587,
    name: "onlineService-components-SearchBox"
  }, {
    path: "/onlineService/components/SmartMatchResults",
    component: _062f6444,
    name: "onlineService-components-SmartMatchResults"
  }, {
    path: "/onlineService/components/TechnicalManager",
    component: _35a29d88,
    name: "onlineService-components-TechnicalManager"
  }, {
    path: "/overall/components/al-selector",
    component: _30dca79a,
    name: "overall-components-al-selector"
  }, {
    path: "/overall/components/demandCard",
    component: _1efa9ab2,
    name: "overall-components-demandCard"
  }, {
    path: "/roadShow/components/activityCard",
    component: _1d090dd4,
    name: "roadShow-components-activityCard"
  }, {
    path: "/screen/components/collegeLeft1",
    component: _8de1948e,
    name: "screen-components-collegeLeft1"
  }, {
    path: "/screen/components/collegeLeft2",
    component: _8dc5658c,
    name: "screen-components-collegeLeft2"
  }, {
    path: "/screen/components/collegeLeft3",
    component: _8da9368a,
    name: "screen-components-collegeLeft3"
  }, {
    path: "/screen/components/collegeMid1",
    component: _f6aa79ec,
    name: "screen-components-collegeMid1"
  }, {
    path: "/screen/components/collegeMid2",
    component: _f68e4aea,
    name: "screen-components-collegeMid2"
  }, {
    path: "/screen/components/collegeMid3",
    component: _f6721be8,
    name: "screen-components-collegeMid3"
  }, {
    path: "/screen/components/collegeRight1",
    component: _59d2e514,
    name: "screen-components-collegeRight1"
  }, {
    path: "/screen/components/collegeRight2",
    component: _59b6b612,
    name: "screen-components-collegeRight2"
  }, {
    path: "/screen/components/collegeRight3",
    component: _599a8710,
    name: "screen-components-collegeRight3"
  }, {
    path: "/screen/components/fieldMid1",
    component: _18889bed,
    name: "screen-components-fieldMid1"
  }, {
    path: "/screen/components/fieldMid3",
    component: _18a4caef,
    name: "screen-components-fieldMid3"
  }, {
    path: "/screen/components/itemMap",
    component: _0c8a1fb3,
    name: "screen-components-itemMap"
  }, {
    path: "/screen/components/itemMap2",
    component: _f65cffe2,
    name: "screen-components-itemMap2"
  }, {
    path: "/screen/components/itemMap3",
    component: _f640d0e0,
    name: "screen-components-itemMap3"
  }, {
    path: "/screen/components/table",
    component: _13200838,
    name: "screen-components-table"
  }, {
    path: "/screen/components/toolTip",
    component: _cd70c6bc,
    name: "screen-components-toolTip"
  }, {
    path: "/screen/directive/dateTime",
    component: _73fbcb91,
    name: "screen-directive-dateTime"
  }, {
    path: "/screen/directive/demandArea",
    component: _ae796158,
    name: "screen-directive-demandArea"
  }, {
    path: "/screen/directive/directives",
    component: _29c3f970,
    name: "screen-directive-directives"
  }, {
    path: "/screen/directive/eight",
    component: _60f1e013,
    name: "screen-directive-eight"
  }, {
    path: "/screen/directive/first",
    component: _4799435c,
    name: "screen-directive-first"
  }, {
    path: "/screen/directive/five",
    component: _758a28cc,
    name: "screen-directive-five"
  }, {
    path: "/screen/directive/four",
    component: _61205eb4,
    name: "screen-directive-four"
  }, {
    path: "/screen/directive/nine",
    component: _6bfc099a,
    name: "screen-directive-nine"
  }, {
    path: "/screen/directive/second",
    component: _719f9d58,
    name: "screen-directive-second"
  }, {
    path: "/screen/directive/seven",
    component: _551517d5,
    name: "screen-directive-seven"
  }, {
    path: "/screen/directive/six",
    component: _f03294c0,
    name: "screen-directive-six"
  }, {
    path: "/screen/directive/ten",
    component: _ed42b6f6,
    name: "screen-directive-ten"
  }, {
    path: "/screen/directive/three",
    component: _54d17ca4,
    name: "screen-directive-three"
  }, {
    path: "/supplyNew/components/achievementCard",
    component: _76558754,
    name: "supplyNew-components-achievementCard"
  }, {
    path: "/supplyNew/components/al-selector",
    component: _186b5936,
    name: "supplyNew-components-al-selector"
  }, {
    path: "/supplyNew/components/demandCard",
    component: _60414596,
    name: "supplyNew-components-demandCard"
  }, {
    path: "/supplyNew/components/filter",
    component: _3e916dc8,
    name: "supplyNew-components-filter"
  }, {
    path: "/supplyNew/components/kxjsCard",
    component: _0edc8efe,
    name: "supplyNew-components-kxjsCard"
  }, {
    path: "/supplyNew/components/serviceCard",
    component: _75490f5a,
    name: "supplyNew-components-serviceCard"
  }, {
    path: "/measurement/baseSheshi/largeYiqi/:id",
    component: _1aa8ded2,
    name: "measurement-baseSheshi-largeYiqi-id"
  }, {
    path: "/measurement/baseSheshi/shiyanshi/:id",
    component: _2d0f9cd6,
    name: "measurement-baseSheshi-shiyanshi-id"
  }, {
    path: "/measurement/chengguo/guifan/:id",
    component: _17324a57,
    name: "measurement-chengguo-guifan-id"
  }, {
    path: "/measurement/chengguo/xianjin/:id",
    component: _6d54b818,
    name: "measurement-chengguo-xianjin-id"
  }, {
    path: "/technicalContractsRegistration/list/detail/:id?",
    component: _339e99eb,
    name: "technicalContractsRegistration-list-detail-id"
  }, {
    path: "/branch/businessIncubation/:id",
    component: _ecbfb33c,
    name: "branch-businessIncubation-id"
  }, {
    path: "/branch/devSearch/:id",
    component: _1ca5172a,
    name: "branch-devSearch-id"
  }, {
    path: "/branch/technicalAchievements/:id",
    component: _ebade622,
    name: "branch-technicalAchievements-id"
  }, {
    path: "/branch/technicalDemand/:Id",
    component: _abf78994,
    name: "branch-technicalDemand-Id"
  }, {
    path: "/branch/technicalManager/:id",
    component: _19aee730,
    name: "branch-technicalManager-id"
  }, {
    path: "/measurement/expert/:id",
    component: _60779758,
    name: "measurement-expert-id"
  }, {
    path: "/measurement/news1/:id",
    component: _670d9db6,
    name: "measurement-news1-id"
  }, {
    path: "/measurement/news2/:id",
    component: _095be692,
    name: "measurement-news2-id"
  }, {
    path: "/technicalContractsRegistration/download/:id?",
    component: _fa54a476,
    name: "technicalContractsRegistration-download-id"
  }, {
    path: "/technicalContractsRegistration/list/:id?",
    component: _12eeacdb,
    name: "technicalContractsRegistration-list-id"
  }, {
    path: "/antincp/:id",
    component: _48bb68c4,
    name: "antincp-id"
  }, {
    path: "/collegeNews/:id",
    component: _3eb7e3d6,
    name: "collegeNews-id"
  }, {
    path: "/expert/:id",
    component: _b49616b6,
    name: "expert-id"
  }, {
    path: "/laboratory/:id",
    component: _70e8012e,
    name: "laboratory-id"
  }, {
    path: "/lasaDemand/:id?",
    component: _50a9a129,
    name: "lasaDemand-id"
  }, {
    path: "/news/:id",
    component: _4a6af364,
    name: "news-id"
  }, {
    path: "/overall/:id?",
    component: _43211e58,
    name: "overall-id"
  }, {
    path: "/publicity/:id",
    component: _3e9cf9b0,
    name: "publicity-id"
  }, {
    path: "/",
    component: _e542f99c,
    name: "index"
  }, {
    path: "/technicalContractsRegistration/index",
    redirect: "/technicalContractsRegistration"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
